import Rellax from 'rellax';

class Stage {
    constructor (element) {
        this.$stage = element;
        this.$stageImage = this.$stage.querySelector('.stage__image-holder');
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        this.setParallax();
    }

    setParallax () {
        if (this.$stageImage) {
            const animated = this.$stageImage.getAttribute('animated');
            if (animated === null) {
                new Rellax(this.$stageImage, { // eslint-disable-line
                    speed: 3.75,
                    center: false,
                    wrapper: null,
                    round: true,
                    vertical: true,
                    horizontal: false
                });

                this.$stageImage.setAttribute('animated', true);
            }
        }
    }
}

export { Stage };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $stageContainer = $context.querySelectorAll('[data-stage="root"]');
        for (let i = 0; i < $stageContainer.length; i++) {
            const stage = new Stage($stageContainer[i]);

            stage.initialize();
        }
    }
});
